import _ from 'lodash';

import { caseInsensitiveIncludes } from 'utils/string';

export const filterActiveTagOptions = (options, { inputValue }) =>
  options.filter(({ name, isDeleted }) => !isDeleted && caseInsensitiveIncludes(name, inputValue));

export const isSameTagOption = (option, value) => option.value === value?.value;

export const getSelectedTagOption = ({ tagsOptions, tagId }) => {
  if (_.isNil(tagId)) {
    return null;
  }

  return tagsOptions.find(({ value }) => value === tagId) ?? { name: tagId, value: tagId };
};
